// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1AZHk","left":"StickyBox_left__3mW15","right":"StickyBox_right__7f_6M"};